const RenameIcon = ({ color = "#808080" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.17497 21.0004C3.82497 21.0837 3.5208 20.9962 3.26247 20.7379C3.00414 20.4796 2.91664 20.1754 2.99997 19.8254L3.99997 15.0504L8.94997 20.0004L4.17497 21.0004ZM8.94997 20.0004L3.99997 15.0504L15.45 3.60039C15.8333 3.21706 16.3083 3.02539 16.875 3.02539C17.4416 3.02539 17.9166 3.21706 18.3 3.60039L20.4 5.70039C20.7833 6.08372 20.975 6.55872 20.975 7.12539C20.975 7.69206 20.7833 8.16706 20.4 8.55039L8.94997 20.0004ZM16.875 5.00039L6.52497 15.3504L8.64997 17.4754L19 7.12539L16.875 5.00039Z"
        fill={color}
      />
    </svg>
  );
};

export default RenameIcon;
